import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LayoutUtilsService, QueryParamsModel } from '../../../../../../../../core/_base/crud';
import { MatSort } from '@angular/material/sort';
import {
  ContactModel,
  ContactsService,
  selectContactsLoginHistoryPageLastQuery,
} from '../../../../../../../../core/lists';
import { MatPaginator } from '@angular/material/paginator';
import { merge } from 'rxjs';
import { distinctUntilChanged, skip, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { ContactsLoginHistoryDatasource } from '../../../../../../../../core/lists/_data-sources/contacts-login-history.datasource';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../../../../../core/reducers';
import { ContactsLoginHistoryPageRequested } from '../../../../../../../../core/lists/_actions/contact-login-history.actions';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-device-history',
  templateUrl: './device-history.component.html',
  styleUrls: ['./device-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceHistoryComponent implements OnInit, OnDestroy {
  private subscriptions: any[] = [];
  @Input() result;
  @Input() contact_id;
  @Output() totalCount = new EventEmitter<any>();
  displayedColumns = [
    'application_name',
    'ipAddress',
    'created',
    'status',
    'terminationTime',
    'terminationReason',
  ];
  dataSource: ContactsLoginHistoryDatasource;
  @ViewChild('sort1', { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  dataToSort;
  lastQuery: QueryParamsModel;
  selection = new SelectionModel<ContactModel>(true, []);

  constructor(
    private layoutUtilsService: LayoutUtilsService,
    public dialog: MatDialog,
    private contactService: ContactsService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.dataToSort = [];
    const sortSubscription = this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    this.subscriptions.push({ id: 1, sub: sortSubscription });
    const paginatorSubscriptions = merge(this.sort.sortChange, this.paginator.page)
      .pipe(tap(() => this.loadLoginHistory()))
      .subscribe();
    this.subscriptions.push({ id: 2, sub: paginatorSubscriptions });
    // Init DataSource
    this.dataSource = new ContactsLoginHistoryDatasource(this.store);
    const entitiesSubscription = this.dataSource.entitySubject
      .pipe(skip(1), distinctUntilChanged())
      .subscribe();
    this.subscriptions.push({ id: 4, sub: entitiesSubscription });
    const lastQuerySubscription = this.store
      .pipe(select(selectContactsLoginHistoryPageLastQuery))
      .subscribe((res) => (this.lastQuery = res));
    // Load last query from store
    this.subscriptions.push({ id: 5, sub: lastQuerySubscription });

    // Read from URL itemId, for restore previous state
    this.dataSource.paginatorTotal$.subscribe((res) => {
      this.totalCount.emit(res);
    });
    this.loadLoginHistory();
  }

  loadLoginHistory() {
    this.selection.clear();
    const queryParams = new QueryParamsModel(
      '',
      this.sort.direction !== '' ? this.sort.direction : 'desc',
      !this.sort.active || this.sort.active === '' ? 'created' : this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize,
    );
    this.store.dispatch(
      new ContactsLoginHistoryPageRequested({ id: this.contact_id, page: queryParams }),
    );
    this.selection.clear();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }
}
